import * as Sentry from '@sentry/react';

// Sentry-Konfiguration
export function initSentry() {
  // Nur initialisieren wenn DSN konfiguriert ist
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
  if (!sentryDsn || sentryDsn.includes('your-dsn@sentry.io')) {
    console.warn('Sentry DSN nicht konfiguriert - Sentry wird nicht initialisiert');
    return;
  }
  
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || 'development',
    // Performance-Monitoring aktivieren
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // Error-Sampling
    sampleRate: 1.0,
    // Release-Tracking
    release: process.env.REACT_APP_VERSION || '1.0.0',
    // User-Context
    beforeSend(event) {
      // Sensitive Daten filtern
      if (event.user) {
        delete event.user.ip_address;
      }
      return event;
    },
  });
}

// Web Vitals Integration
export function reportWebVitals() {
  import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
    // Web Vitals an Sentry senden (nur verfügbare Metriken)
    onCLS((metric) => Sentry.addBreadcrumb({
      message: `Web Vital: CLS`,
      category: 'web-vitals',
      data: metric,
      level: 'info',
    }));
    
    onFCP((metric) => Sentry.addBreadcrumb({
      message: `Web Vital: FCP`,
      category: 'web-vitals',
      data: metric,
      level: 'info',
    }));
    
    onLCP((metric) => Sentry.addBreadcrumb({
      message: `Web Vital: LCP`,
      category: 'web-vitals',
      data: metric,
      level: 'info',
    }));
    
    onTTFB((metric) => Sentry.addBreadcrumb({
      message: `Web Vital: TTFB`,
      category: 'web-vitals',
      data: metric,
      level: 'info',
    }));
  });
}

// Performance-Monitoring-Helper
export function trackPerformance(name: string, startTime: number) {
  const duration = performance.now() - startTime;
  Sentry.addBreadcrumb({
    message: `Performance: ${name}`,
    category: 'performance',
    data: { duration },
    level: 'info',
  });
}

// API-Response-Time-Tracking
export function trackApiCall(endpoint: string, method: string, duration: number, status: number) {
  Sentry.addBreadcrumb({
    message: `API Call: ${method} ${endpoint}`,
    category: 'api',
    data: { 
      endpoint, 
      method, 
      duration, 
      status,
      success: status >= 200 && status < 300
    },
    level: status >= 400 ? 'error' : 'info',
  });
}

// User-Context setzen
export function setUserContext(user: any) {
  Sentry.setUser({
    id: user.id,
    username: user.username,
    email: user.email,
    role: user.role,
  });
}

// Custom Error-Reporting
export function reportError(error: Error, context?: any) {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext('errorContext', context);
    }
    Sentry.captureException(error);
  });
}
